// libs
import React, { memo } from 'react';

// hooks
import useDealsPlatformRedirect from 'shared/hooks/useDealsPlatformRedirect';

// component
import API from 'shared/layouts/LandingPage/API';
import Child from './Child';

// defs
interface ILadingPageDesktopProps {
  pageName: string;
}

function LadingPageDesktop({ pageName }: ILadingPageDesktopProps) {
  const shouldRenderWithDealsPlatform = useDealsPlatformRedirect(pageName);
  return (
    <API pageName={pageName} shouldTransformForDealsPlatform={shouldRenderWithDealsPlatform}>
      {Child}
    </API>
  );
}

export default memo(LadingPageDesktop);
